

































import Vue from 'vue'
import Component from 'vue-class-component'
import {Mutation, State} from "vuex-class";
import PrintResult from "@/modules/reservation/model/PrintResult";
import {Ref} from "vue-property-decorator";

/**
 * Imprime la reserva
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PrintReservation extends Vue {
    /**
     * Controla la visibilidad de la pantalla
     */
    @State(state => state.reservation.displayPrintReservation)
    public display: boolean

    @State(state => state.reservation.loadingPrint)
    public loading: boolean

    @Mutation('reservation/TOGGLE_DISPLAY_PRINT_RESERVATION')
    public toggleDisplay: boolean

    @State(state => state.reservation.printResult)
    public result: PrintResult

    @Ref('contentFrame')
    public contentFrame: HTMLFrameElement

    public get frameSrc () {
        if (this.result.failed) {
            return ''
        }

        const { contentType, content } = this.result

        return `data:${contentType};charset=utf-8,${content}`
    }
}

